"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const useAsyncState_1 = __importDefault(require("../../hooks/useAsyncState"));
const profile_1 = __importDefault(require("../../utils/loader/profile"));
const useAuthContext_1 = __importDefault(require("./useAuthContext"));
function useProfileContext() {
    const [account] = (0, useAuthContext_1.default)();
    return (0, useAsyncState_1.default)(async () => (!account ? null : profile_1.default.load(account)), [account]);
}
exports.default = useProfileContext;
